import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { TrainingAnonymousService } from '../../services/training-anonymous.service';
import { HttpStatusCode } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-decline-invitation-modal',
  standalone: false,
  templateUrl: './decline-invitation-modal.component.html',
  styleUrl: './decline-invitation-modal.component.scss',
})
export class DeclineInvitationModalComponent {
  @Input() showModal = false;
  @Input() trainingKey!: string;
  @Input() accessToken!: string;

  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() onInviteDeclined = new EventEmitter();

  constructor(
    private trainingAnonymousService: TrainingAnonymousService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  declineInvitation = () => {
    this.loadingService
      .load(
        this.trainingAnonymousService.declineTraining(
          this.trainingKey, this.accessToken
        )
      )
      .subscribe({
        next: () => {
          this.toastrService.success(
            this.translateService.instant(
              "MY-INVITATION.INVITATION-DECLINED-SUCCESSFULLY"
            )
          );
          this.onInviteDeclined.emit();
          this.closeModal();
        },
        error: (error) => {
          if (error.status === HttpStatusCode.NotFound) {
            this.toastrService.error(
              this.translateService.instant(
                "MY-INVITATION.INCORRECT-TOKEN-PROVIDED"
              )
            );
          } else {
            this.toastrService.error(
              this.translateService.instant("COMMON.AN-ERROR-HAS-OCCURRED")
            );
          }
        },
      });
  }

  dismiss = () => {
    this.closeModal();
  }

  private closeModal() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
